import { render, staticRenderFns } from "./docPop.vue?vue&type=template&id=b967a0ee"
import script from "./docPop.vue?vue&type=script&lang=js"
export * from "./docPop.vue?vue&type=script&lang=js"
import style0 from "./docPop.vue?vue&type=style&index=0&id=b967a0ee&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b967a0ee')) {
      api.createRecord('b967a0ee', component.options)
    } else {
      api.reload('b967a0ee', component.options)
    }
    module.hot.accept("./docPop.vue?vue&type=template&id=b967a0ee", function () {
      api.rerender('b967a0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docPop.vue"
export default component.exports